// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"418":"9985b78b","668":"04e58968"}[chunkId] + ".js";
};